import request from '@/utils/request'
//登录
export function phoneLogin() {
  return request({
    url: 'ccesl/soft-phone/phone-init',
    method: 'get',
  })  
}
//拨打
export function phoneCall(query) {
  return request({
    url: 'ccesl/call-out/make-call',
    method: 'get',
    params: query
  })  
}
export function phoneCall1(query) {
  return request({
    url: 'ccesl/call-out/make-double-call',
    method: 'get',
    params: query
  })  
}
//转接
export function phoneTransfer(query) {
  return request({
    url: 'ccesl/soft-phone/transfer',
    method: 'get',
    params: query
  })  
}

//最近通话
export function phoneHistory(query) {
  return request({
    url: 'report/report-cdr/history-call',
    method: 'get',
    params: query
  })  
}

//批次列表
export function getBatch(query) {
  return request({
    url: 'sip/agent-call/batch-list',
    method: 'get',
    params: query
  })  
}

//批次任务详情
export function getBatchInfo(query) {
  return request({
    url: 'sip/agent-call/agent-batch-info',
    method: 'get',
    params: query
  })  
}

//软电话操作
export function getPhoneControl(action,query) {
  return request({
    url: 'ccesl/soft-phone/phone-control/'+ action,
    method: 'get',
    params: query
  })  
}

//留资数据返显
export function getcustomerInfo(query) {
  return request({
    url: 'sip/call-record/get-customer-info',
    method: 'get',
    params: query
  })  
}

//留资保存
export function callRecord(data) {
  return request({
    url: 'sip/call-record',
    method: 'post',
    data: data
  })
}
//查询客户信息
export function queryDataInfo(query) {
  return request({
    url: 'sip/agent-call/data-title',
    method: 'get',
    params: query
  })
}

//发送短信
export function smsSend(query) {
  return request({
    url: 'system/sms/send',
    method: 'get',
    params: query
  })
}
//咨询三方
export function phoneConsult(query) {
  return request({
    url: 'ccesl/soft-phone/three-way',
    method: 'get',
    params: query
  })
}